import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, RequireAdmin, RequireAuth, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Apply from "./pages/Apply";
import ApplySuccess from "./pages/ApplySuccess";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Invite from "./pages/Invite";
import AlmostThere from "./pages/AlmostThere";
import PortalLayout from "./pages/portal/Layout";
import Reading from "./pages/portal/Reading";
import Discussion from "./pages/portal/Discussion";
import EventsPage from "./pages/portal/Events";
import Members from "./pages/portal/Members";
import Profile from "./pages/portal/Profile";
import AdminApplications from "./pages/admin/Applications";
import AdminApplicationDetail from "./pages/admin/ApplicationDetail";

function LandingOrPortal() {
  const { user, loading } = useAuth();
  if (loading) return null; // brief flash; AuthProvider resolves fast
  if (user) return <Navigate to="/portal" replace />;
  return <Landing />;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingOrPortal />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/apply/success" element={<ApplySuccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="/almost-there" element={<AlmostThere />} />

        {/* Gated portal — Reading is the index/landing view */}
        <Route
          path="/portal"
          element={
            <RequireAuth>
              <PortalLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Reading />} />
          <Route path="discussion" element={<Discussion />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="members" element={<Members />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Admin-only */}
        <Route
          path="/admin/applications"
          element={
            <RequireAdmin>
              <AdminApplications />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/applications/:id"
          element={
            <RequireAdmin>
              <AdminApplicationDetail />
            </RequireAdmin>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
